import {
  disableGoogleAds,
  enableGoogleAds,
  initGoogleAds,
  isGoogleAdsInitialized,
  parseGoogleAdsConfig,
  trackGoogleAdsPageView,
} from '~/utils/googleAds'
import { markTrackingLoaded } from '~/utils/trackingScope'

export default defineNuxtPlugin(async () => {
  const { fetchSettings, settings, loaded } = useSiteSettings()
  const { marketing, hydrate } = useCookieConsent()
  const { trackableShop } = useTrackingScope()
  const router = useRouter()

  if (!loaded.value) {
    await fetchSettings()
  }

  hydrate()

  async function syncGoogleAds() {
    const slug = trackableShop()
    if (!slug) return

    const config = parseGoogleAdsConfig(settings.value.google_ads)
    if (!config.enabled) return

    if (!marketing.value) {
      disableGoogleAds()
      return
    }

    enableGoogleAds()

    if (!isGoogleAdsInitialized()) {
      markTrackingLoaded(slug)
      const path = router.currentRoute.value.fullPath
      if (await initGoogleAds(config.conversionId)) {
        trackGoogleAdsPageView(path)
      }
    }
  }

  watch([marketing, loaded, () => router.currentRoute.value.path], () => {
    void syncGoogleAds()
  }, { immediate: true })

  router.afterEach((to) => {
    if (!marketing.value || !trackableShop(to)) return
    trackGoogleAdsPageView(to.fullPath)
  })
})
